import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { data } from 'jquery';
import { AlertService, PartnerViewService } from '../_services/index';
import { AwardToRewardListService } from '../_services/award-to-reward-list.service';
import { FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-award-to-reward-partner-view',
  templateUrl: './award-to-reward-partner-view.component.html',
  styleUrls: []
})
export class AwardToRewardPartnerViewComponent implements OnInit {
  remarkForm:any
  atr_status: any;
  remark_val: any ;
  url :any="https://nitistg.s3.ap-south-1.amazonaws.com"

  constructor(
      public router: Router,
      public activatedRoute: ActivatedRoute,
      private alertService: AlertService,
      private dataService:AwardToRewardListService,
      private fb:FormBuilder
  ) { }

  showloding = true;
  lodingImage = false;
  urlParams:any;

  atrDetails = {
    "id": '',
    "full_image":'',
    "app_opening_date": '',
    "descriptions": '',
    "focus_region_name": '',
    "focus_region": '',
    "mode": '',
    "eligibility": '',
    "name": '',
    "announcement_date":'',
    "remark":''
  };

  competetion = {
   "competetion_criteria":'',
   "competetion_detail":'',
   "competition_entity" :'',
   "competition_process":''
  }

  handholding = {
    "sector_name":'',
    "stage_of_enterprise_name":'',
    "handholding_support_details" :'',
    "ecosystem_need_name":''
  }

  reward = {
    "reward_details":'',
  }

  award_ceremony = {
    "award_ceremony_details":'', 
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.urlParams = params['id'];
    });
    
    this.getPartnerDetails();

    this.remarkForm = this.fb.group({
      atr_remarks: ['', [Validators.required]]
      // You can add more validators as needed
    });
  }

  get atr_remark() {
    return this.remarkForm.get('atr_remarks');
  }

  getPartnerDetails(){
      this.loadShow();
      this.dataService.viewAwardToReward(this.urlParams).subscribe((res:any)=>{
             console.log(res.data,"ressssss");
                if(res.data) {
                this.atrDetails = res.data    
                }
                if(res.data['competetion'][0]) {
                  this.competetion = res.data['competetion'][0];
                }
                if(res.data['handholding'][0]) {
                  this.handholding = res.data['handholding'][0];
                }
                if(res.data['reward'][0]) {
                  this.reward = res.data['reward'][0]
                }
                if(res.data['award_ceremony'][0]) {
                  this.award_ceremony = res.data['award_ceremony'][0];
                }            
                this.loadHide();
            })
         }


  saveSubmit(val,status){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.loadShow();

    var data = {
      "id": this.urlParams, 
      "status": status,
      "remark": val,       
    };
    console.log(data);
    
    this.dataService.updateAwardToReward(data)
      .pipe().subscribe(data =>{                
        if(data['status']==200){
          this.alertService.success(data['mesg'], true);
          console.log(data)
          
        }else if(data['status']==422){
          this.alertService.error(data['mesg'], true);
        }
        
        setTimeout(()=>{
          this.router.navigate(['award-to-reward']);
        }, 3000);
      },error =>{
        this.alertService.error(error);
        this.loadHide();
      });
   }
   
   rejectStatus(val,status){
    if(this.remarkForm.valid){
    this.saveSubmit(val,status)
   }else{
    this.remarkForm.markAllAsTouched();
    }
  }

  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }
}

